import React from 'react';
import ReactDOM from 'react-dom/client';
import { useWizardLauncher } from './hooks/useWizardLauncher';
import ToastNotification from '../Common/ToastNotification'; 

const MobileWizardLeftPanelButton = () => {
    const { launchWizard, ConfirmModalComponent } = useWizardLauncher();

    const handleButtonClick = (event) => {
        event.preventDefault();
        launchWizard({ fromLeftPanel: true });
    };

    return (
        <>
            <button
                onClick={handleButtonClick}
                id="openMobileWizard"
                className="btn btn-default hvr-glow"
                style={{ width: '280px', marginLeft: '5px' }}
            >
                Add or Remove Sections/Objects
            </button>
            {ConfirmModalComponent}
            <ToastNotification />
        </>
    );
};

MobileWizardLeftPanelButton.render = function (targetElementId, props) {
    const targetElement = document.getElementById(targetElementId);
    if (targetElement) {
        let root = targetElement._reactRoot;
        if (!root) {
            root = ReactDOM.createRoot(targetElement);
            targetElement._reactRoot = root;
        }
        root.render(<MobileWizardLeftPanelButton {...props} />);
    } else {
        console.error(`Left Panel Button: Target element with ID "${targetElementId}" not found.`);
    }
};

export default MobileWizardLeftPanelButton;